// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1fCsm","logout":"Header_logout__1elhx","print":"Header_print__19brL"};